module.exports = __webpack_public_path__ + "static/media/ic_tbox.fc59d673.svg";